import React from 'react';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import { useDashboardContext } from '../../pages/DashboardLayout';

const LinksHeader = () => {
  const { user } = useDashboardContext();
  return (
    <div className="bg-white px-6 py-6 sm:py-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
          Linkverwaltung
        </h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
          Hier kannst du die Verlinkungen anpassen, die auf deiner
          sVisit-Profilseite angezeigt werden.
        </p>
        <a href="https://www.svisit.ch/blog/links-hinzuf%C3%BCgen">
          <PrimaryButton content="Anleitung" />
        </a>
        <a href={`/c/${user.url}`} target="_blank">
          <SecondaryButton content="Zu deiner Seite &rarr;" />
        </a>
      </div>
    </div>
  );
};

export default LinksHeader;
